const kindTone: Record<string, { dot: string; label: string }> = {
  claim: { dot: "bg-accent-500", label: "初始指控" },
  spread: { dot: "bg-secondary-500", label: "扩散阶段" },
  response: { dot: "bg-primary-600", label: "当事方回应" },
  turn: { dot: "bg-accent-600", label: "关键转向" },
  clarify: { dot: "bg-primary-800", label: "澄清落地" },
};

export interface TimelineNode {
  time: string;
  title: string;
  detail: string;
  kind?: string;
}

export default function CaseTimeline({ nodes }: { nodes: TimelineNode[] }) {
  return (
    <ol className="relative border-l border-background-300 pl-6 md:pl-8">
      {nodes.map((node, index) => {
        const tone = kindTone[node.kind ?? "claim"] ?? kindTone.claim;
        const isLast = index === nodes.length - 1;
        return (
          <li key={`${node.time}-${node.title}`} className={`relative ${isLast ? "" : "pb-8"}`}>
            <span
              className={`absolute -left-[calc(1.5rem+5px)] top-1.5 h-2.5 w-2.5 rounded-full ring-4 ring-background-50 md:-left-[calc(2rem+5px)] ${tone.dot}`}
              aria-hidden="true"
            />
            <div className="flex flex-wrap items-center gap-3">
              <time className="font-heading text-xs font-semibold tracking-wide text-foreground-700">{node.time}</time>
              <span className="rounded-full bg-background-100 px-2.5 py-0.5 text-[10px] font-medium text-foreground-700">
                {tone.label}
              </span>
            </div>
            <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">{node.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{node.detail}</p>
          </li>
        );
      })}
    </ol>
  );
}